import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"
import { ContactEnum } from "./Contact.schema"

const disabled = { disabled: true }

const commonRoleConf = {
  [ContactEnum.PRIMARY_HOLDER_PHONE]: disabled,
  [ContactEnum.PRIMARY_HOLDER_EMAIL]: disabled,
}

const adhRoleConf = {
  ...commonRoleConf,
  [ContactEnum.EMAIL]: disabled,
  [ContactEnum.PHONE]: disabled,
  [ContactEnum.MOBILE]: disabled,
  [ContactEnum.FAX]: disabled,
}

export const formRoleConf: RoleStrategy<
  Partial<Record<ContactEnum, { disabled?: boolean }>>
> = {
  [ROLES.ADMIN]: commonRoleConf,
  [ROLES.ADHERENT_HOLDER]: adhRoleConf,
  [ROLES.ADHERENT_TEAM]: adhRoleConf,
}
